// src/pages/volunteering/fieldEditor.js
import React, { useEffect, useState } from "react";
import { Button, Divider, Input, Modal, Select, Space, Switch, Typography } from "antd";

const { Title, Text } = Typography;
const { Option } = Select;

const FieldEditor = ({ close, fields, setFields, editIndex }) => {
  const isEditing = editIndex !== null;

  const [label, setLabel] = useState("");
  const [type, setType] = useState("text");
  const [required, setRequired] = useState(false);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (isEditing) {
      const field = fields[editIndex];
      setLabel(field.label);
      setType(field.type);
      setRequired(field.required || false);
      setOptions(field.options || []);
    }
  }, [editIndex, fields, isEditing]);

  const handleSave = () => {
    const newField = {
      id: label.toLowerCase().replace(/\s+/g, "_"),
      label,
      type,
      required,
      options: type === "dropdown" ? options : []
    };

    const updatedFields = [...fields];
    if (isEditing) updatedFields[editIndex] = newField;
    else updatedFields.push(newField);

    setFields(updatedFields);
    close();
  };

  const addOption = () => {
    setOptions([...options, ""]);
  };

  const updateOption = (value, index) => {
    const updated = [...options];
    updated[index] = value;
    setOptions(updated);
  };

  const removeOption = (index) => {
    setOptions(options.filter((_, i) => i !== index));
  };

  return (
    <Modal open title={isEditing ? "Edit Field" : "Add Field"} onCancel={close} onOk={handleSave} okText="Save Field" okButtonProps={{ disabled: !label }} width={600}>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        {/* Label */}
        <div>
          <Text strong>Label</Text>
          <Input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Enter field label" />
        </div>

        {/* Field Type */}
        <div>
          <Text strong>Field Type</Text>
          <Select value={type} onChange={setType} style={{ width: "100%" }}>
            <Option value="text">Text</Option>
            <Option value="number">Number</Option>
            <Option value="dropdown">Dropdown</Option>
            <Option value="checkbox">Checkbox</Option>
            <Option value="email">Email</Option>
            <Option value="phone">Phone</Option>
            <Option value="date">Date</Option>
            <Option value="file">File Upload</Option>
            <Option value="textarea">Textarea</Option>
          </Select>
        </div>

        {/* Required */}
        <div>
          <Space>
            <Switch checked={required} onChange={setRequired} />
            <Text>Required</Text>
          </Space>
        </div>

        {/* Dropdown Options */}
        {type === "dropdown" && (
          <>
            <Divider />
            <Title level={5}>Options</Title>

            {options.map((opt, index) => (
              <Space key={index} style={{ width: "100%" }}>
                <Input value={opt} onChange={(e) => updateOption(e.target.value, index)} placeholder={`Option ${index + 1}`} />
                <Button danger onClick={() => removeOption(index)}>
                  Delete
                </Button>
              </Space>
            ))}

            <Button type="dashed" onClick={addOption}>
              + Add Option
            </Button>
          </>
        )}
      </Space>
    </Modal>
  );
};

export default FieldEditor;
